class ExpressPaymentButtons extends HTMLElement {
  isPdpCta = (this.dataset.isPdpCta === 'true') ? true : false;

  constructor() {
    super();
    this.nodeAttributes = ['action','data-testid','href','title','class'];

    this.availablePaymentMethods = {
      shopifypay: {
        name: 'Shopify Pay',
        targetKeywords: ['shopifypay'],
        isAvailable: false,
      },
      paypal: {
        name: 'PayPal',
        targetKeywords: ['paypal'],
        isAvailable: false,
      },
      amazonpay: {
        name: 'Amazon Pay',
        targetKeywords: ['amazon'],
        isAvailable: false,
      },
      googlepay: {
        name: 'Google Pay',
        targetKeywords: ['googlepay'],
        isAvailable: false,
      },
      applepay: {
        name: 'Apple Pay',
        targetKeywords: ['applepay'],
        isAvailable: false,
      },
      klarna: {
        name: 'Klarna',
        targetKeywords: ['klarna'],
        isAvailable: false,
      },
    };
  }

  connectedCallback() {

    // listen to changes in content
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // pass in the ExpressPaymentButtons element
          this.updateVisiblePaymentMethods(this);
        }
      });
    });

    observer.observe(this, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true,
    });
  }

  updateVisiblePaymentMethods(expressPaymentButtonsElement) {

    // convert html nodes to string the target node, lowercase it, and remove spaces
    let targetNodeString = expressPaymentButtonsElement.innerHTML.toString().toLowerCase().replace(/\s/g, '');
    if (this.isPdpCta) {
      let clonedElement = expressPaymentButtonsElement.cloneNode(true);

      clonedElement.querySelector('#shopify-svg-symbols')?.remove();
      targetNodeString = clonedElement.innerHTML.toString().toLowerCase().replace(/\s/g, '');
    }

    // search the string for the target keywords and update the availablePaymentMethods object availability
    Object.keys(this.availablePaymentMethods).forEach((key) => {
      this.availablePaymentMethods[key].targetKeywords.forEach((keyword) => {
        if (targetNodeString.includes(keyword)) {
          this.availablePaymentMethods[key].isAvailable = true;

          // add the class to the express-payment-buttons element
          this.classList.add(`available-payment-method--${key}`);
        }
      });
    });

    Object.keys(this.availablePaymentMethods).forEach((key) => {
      if (this.availablePaymentMethods[key].isAvailable) {
        this.nodeAttributes.forEach((attribute) => {

          // loop through this.availablePaymentMethods[key].targetKeywords and find the first match
          this.availablePaymentMethods[key].targetKeywords.forEach((keyword) => {
            const query = `[${attribute}*="${keyword}" i]`;
            const node = expressPaymentButtonsElement.querySelector(query);
            if (node) {
              if (this.isPdpCta) {
                node.parentNode.classList.add(`express-payment-buttons--${key}`);
              } else {
                node.closest('li').classList.add(`express-payment-buttons--${key}`);
              }

              this.classList.remove('hidden');
              return;
            }
          });
        });
      }
    });
  }
}

window.customElements.define('express-payment-buttons', ExpressPaymentButtons);
